module.exports = __webpack_public_path__ + "img/northen-cyprus.934bed50.svg";